<template>
  <div>
    <close-button @click="close()" class="close-button"></close-button>
    <section v-if="!forgot & !requireMfa">
      <transition name="overlay-fade">
        <div class="overlay-message" v-show="loginOk">
          <p class="system-text">U bent nu ingelogd</p>
        </div>
      </transition>
      <div class="dialog-header">
        <h1>Inloggen</h1>
      </div>
      <div class="dialog-content">
        <div class="form-holder">
          <form
            id="login-form"
            name="loginForm"
            method="post"
            action="/login"
            novalidate
            @submit.prevent="logMeIn($event)"
          >
            <div class="row">
              <label>E-mailadres</label>
              <input
                autocomplete="username"
                type="email"
                name="username"
                v-model="loginForm.username"
                :class="{
                  'login-invalid': loginInvalid,
                  invalid: loginInvalid
                }"
                @blur="checkUser"
                class="grey-field"
                ref="email"
              />
            </div>
            <div class="row">
              <label>Wachtwoord</label>
              <password-input
                v-model="loginForm.password"
                :password="loginForm.password"
                :invalid="loginInvalid"
                autocomplete="current-password"
              ></password-input>
            </div>

            <div class="error-text" v-show="loginInvalid">
              <p class="">
                Inloggen mislukt, dit kan komen doordat:
              </p>
              <ul>
                <li>Ongeldige combinatie gebruikersnaam en wachtwoord</li>
                <li>Uw account is nog niet gevalideerd</li>
                <li>De opgegeven gebruikersnaam is niet bij ons bekend</li>
              </ul>
            </div>

            <div class="row">
              <span></span>
              <button
                type="submit"
                class="pill-button default login-btn"
                :style="rootStore.buttons.pillDefault"
                v-show="!inProgress"
              >
                Inloggen
              </button>

              <bouncing-spinner
                class="spinner-ct"
                v-show="inProgress"
              ></bouncing-spinner>
            </div>
          </form>
        </div>
        <div class="footer-btns">
          <button
            class="pill-button secondary"
            @click="forgot = true"
            :style="rootStore.buttons.btnDefault"
          >
            Wachtwoord vergeten
          </button>
          <br />
          <button
            class="pill-button secondary"
            @click="signUp"
            :style="rootStore.buttons.btnDefault"
          >
            Nog geen account?
          </button>
          <template v-if="type === 'both'">
            <div>
              <span>of</span><br />
              <a
                class="main-button pointer"
                v-bind:href="noLoginAction"
                :style="rootStore.buttons.btnDefault"
                target="_blank"
                >Offerteaanvraag per email</a
              >
            </div>
          </template>
        </div>
      </div>
    </section>
    <section v-if="requireMfa">
      <div class="dialog-header">
        <h1>Verificatiecode invoeren</h1>
      </div>
      <div class="dialog-content">
        <div class="form-holder">
          <form
            id="login-form"
            name="loginForm"
            method="post"
            action="/login"
            novalidate
            @submit.prevent="verifyMfa()"
          >
            <p>
              We hebben een verificatiecode gestuurd naar
              {{ loginForm.username }}. Voer de code hieronder in.
            </p>
            <div class="code-row">
              <label>Verificatiecode</label>
              <input
                type="text"
                name="mfaCode"
                ref="mfaCode"
                v-model="loginForm.mfaCode"
                class="grey-field"
                autocomplete="off"
                autofocus
              />
            </div>
            <div class="check-item code-row">
              <span></span>
              <section class="">
                <select-box
                  :selected="loginForm.rememberDevice"
                  @action="toggleRememberDevice()"
                ></select-box>
                <span @click="toggleRememberDevice()"
                  >Onthoud dit apparaat 90 dagen</span
                >
              </section>
            </div>

            <div class="row">
              <span></span>
              <button
                type="submit"
                class="pill-button default login-btn"
                :style="rootStore.buttons.pillDefault"
                v-show="!inProgress"
              >
                Verifiëren
              </button>

              <bouncing-spinner
                class="spinner-ct"
                v-show="inProgress"
              ></bouncing-spinner>
            </div>
            <div class="error-text code-error" v-show="mfaInvalid">
              <p class="">
                De code is ongeldig, dit kan komen doordat:
              </p>
              <ul>
                <li>U een typfout heeft gemaakt</li>
                <li>De code is verlopen</li>
              </ul>
              <button
                class="pill-button secondary new-code-btn"
                @click="mfaRequest"
              >
                Nieuwe code aanvragen
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <section v-if="forgot">
      <transition name="overlay-fade">
        <div class="overlay-message" v-show="validationPending">
          <p class="system-text">
            Voor de validatie van dit account is is er een email gestuurd naar
            {{ forgotForm.username }}.<br />Volg de stappen in deze email om uw
            account te kunnen gebruiken.
          </p>
          <button
            class="pill-button default close-forgot"
            @click="$modal.hide('login')"
            :style="rootStore.buttons.pillDefault"
          >
            Sluiten
          </button>
        </div>
      </transition>
      <transition name="overlay-fade">
        <div class="overlay-message" v-show="forgotOk">
          <p class="system-text">
            Indien u een bestaande Rijnja.nl gebruikersnaam heeft opgegeven
            ontvangt u per e-mail instructies voor het opnieuw instellen van uw
            wachtwoord.
          </p>
          <button
            class="pill-button default close-forgot"
            @click="$modal.hide('login')"
            :style="rootStore.buttons.pillDefault"
          >
            Sluiten
          </button>
        </div>
      </transition>
      <div class="dialog-header">
        <h1>Wachtwoord vergeten</h1>
      </div>
      <div class="dialog-content">
        <p>
          Voer hieronder uw Rijnja.nl gebruikersnaam in en u ontvangt
          instructies voor het instellen van een nieuw wachtwoord.
        </p>
        <div class="form-holder">
          <form
            name="forgotForm"
            action="/forgot"
            method="post"
            @submit.prevent="iForgot"
          >
            <div class="row">
              <label for="email">E-mailadres</label>
              <input
                type="email"
                class="grey-field"
                name="email"
                id="email"
                autocomplete="email"
                v-model="forgotForm.username"
              />
            </div>
            <div class="row">
              <span></span>
              <button
                type="submit"
                class="pill-button default login-btn"
                :disabled="v$.forgotForm.$invalid"
                :style="rootStore.buttons.pillDefault"
                v-show="!inProgress"
              >
                Verzenden
              </button>

              <bouncing-spinner
                class="spinner-ct"
                v-show="inProgress"
              ></bouncing-spinner>
            </div>
          </form>
        </div>
        <div class="footer-btns">
          <button class="pill-button secondary" @click="forgot = false">
            Terug naar inloggen
          </button>
          <br />
          <button class="pill-button secondary" @click="signUp">
            Nog geen account?
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'

import { email, minLength, required } from '@vuelidate/validators'
import {
  login,
  checkRedirect,
  resetPassword,
  verifyMfa,
  mfaRequest
} from '@/api/api.js'
import SignUp from '@/dialogs/SignUp2.vue'
import RegisterRedirect from '@/dialogs/RegisterRedirect.vue'
import { EventBus, Events } from '@/eventbus/EventBus'
import PasswordInput from '@/components/ui/PasswordInput.vue'
import SelectBox from '@/components/ui/SelectBox.vue'
import DialogMixin from '@/mixins/DialogMixin'

export default {
  setup() {
    const v$ = useVuelidate()
    return { v$ }
  },
  components: { SelectBox, PasswordInput },
  props: ['type', 'noLoginAction', 'redirectUrl'],
  mixins: [DialogMixin],
  data() {
    return {
      errorMessage: '',
      validationPending: false,
      forgot: false,
      forgotForm: {
        username: ''
      },
      forgotOk: false,
      inProgress: false,
      loginForm: {
        password: '',
        username: ''
      },
      loginInvalid: false,
      loginOk: false,
      requireMfa: false,
      mfaInvalid: false
    }
  },
  validations: {
    forgotForm: {
      username: {
        email,
        minLength: minLength(4),
        required
      }
    },
    loginForm: {
      password: {
        required
      },
      username: {
        email,
        minLength: minLength(4),
        required
      }
    }
  },
  mounted() {
    this.$refs.email.focus()
  },
  methods: {
    checkUser() {
      if (!this.v$.loginForm.username.$invalid) {
        checkRedirect(this.loginForm.username).then((response) => {
          if (
            response.redirect &&
            response.redirect.restricted &&
            !response.redirect.allowLogin
          ) {
            this.close()

            this.$modal.show(
              RegisterRedirect,
              {
                title: response.redirect.title,
                text: response.redirect.message,
                btnLabel: response.redirect.btnLabel,
                btnUrl: response.redirect.btnUrl,
                callback: (url) => {
                  if (url === '') {
                    this.$emit('close')
                  } else {
                    window.open(response.redirect.btnUrl)
                  }
                }
              },
              {
                height: 'auto',
                width: 380,
                adaptive: true
              }
            )
          }
        })
      }
    },
    signUp() {
      this.$modal.hide('login')

      this.$modal.show(SignUp, null, {
        height: 'auto',
        width: 420,
        scrollable: true
      })
    },
    async verifyMfa() {
      this.inProgress = true

      try {
        const user = await verifyMfa(
          this.loginForm.mfaCode,
          this.loginForm.rememberDevice
        )

        this.mfaInvalid = false
        this.completeLogin(user)
      } catch (error) {
        this.inProgress = false
        this.mfaInvalid = true
      }
    },
    async logMeIn() {
      this.loginInvalid = false
      this.inProgress = true

      try {
        const user = await login(
          this.loginForm.username,
          this.loginForm.password
        )

        if (user.mfaPending) {
          this.requireMfa = true
          this.inProgress = false

          this.$nextTick(() => {
            this.$refs.mfaCode.focus()
          })

          return
        }

        this.completeLogin(user)
      } catch (error) {
        this.loginInvalid = true
        this.inProgress = false
      }
    },
    completeLogin(user) {
      this.inProgress = false
      this.loginOk = true

      this.rootStore.setLogin(user)

      this.rootStore.loadTheme()
      EventBus.emit(Events.LOGGED_IN)

      setTimeout(() => {
        this.$modal.hide('login')
      }, 500)

      if (this.redirectUrl) {
        window.location = this.redirectUrl
      }
    },
    async iForgot() {
      this.inProgress = true

      const forgot = await resetPassword(this.forgotForm.username)

      this.inProgress = false

      if (forgot.result === 'validation pending') {
        this.validationPending = true
      } else if (forgot.error) {
        // error
      } else {
        this.forgotOk = true
      }
    },
    close() {
      EventBus.emit(Events.LOGIN_CANCELLED)
      this.$modal.hide('login')
    },
    toggleRememberDevice() {
      this.loginForm.rememberDevice = !this.loginForm.rememberDevice
    },
    async mfaRequest() {
      await mfaRequest()
      this.notificationDialog('', 'Nieuwe code aangevraagd')
    }
  },
  watch: {
    'loginForm.username': function (val) {
      this.forgotForm.username = val
      this.loginInvalid = false
    },
    'loginForm.password': function () {
      this.loginInvalid = false
    },
    'forgotForm.username': function (val) {
      this.forgotForm.username = val
      this.loginInvalid = false
    }
  }
}
</script>
<style lang="scss" scoped>
.row {
  display: grid;
  grid-template-columns: 85px 1fr;
  grid-gap: 10px;
}

.code-row {
  display: grid;
  grid-template-columns: 95px 1fr;
  grid-gap: 10px;

  label,
  input {
    width: 100%;
    margin-bottom: 15px;
  }
}

.login-button-holder {
  text-align: center;
}

.form-holder {
  padding-bottom: 15px;
}

label {
  width: 85px;
  line-height: 34px;
}

input {
  width: 240px;
  margin-bottom: 20px;
}

.footer-btns {
  text-align: center;

  button:first-child {
    margin-bottom: 2px;
  }
}

.login-btn {
  width: 152px;
}

.spinner-ct {
  margin-top: 5px;
}

.close-forgot {
  margin-top: 15px;
}

.error-text {
  list-style: outside;
  padding-bottom: 18px;

  ul {
    list-style: disc;
    padding-left: 15px;
  }
}

.check-item {
  padding-bottom: 20px;
}

.code-error {
  padding-top: 20px;
  padding-bottom: 0;
}

.new-code-btn {
  margin-left: calc(50% - 85px);
  width: 170px;
  margin-top: 9px;
}
</style>
